import React, { Fragment, useState } from "react";
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider,KeyboardDatePicker } from "@material-ui/pickers";

function InlineDatePickerDemo(props) {
  const [selectedDate, handleDateChange] = useState(new Date());

  return (
    <Fragment>
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
     

      <KeyboardDatePicker
        autoOk
        variant="inline"       
        format="dd/MM/yyyy"
        value={selectedDate}
        InputAdornmentProps={{ position: "start" }}
        onChange={date => handleDateChange(date)}
      />
       </MuiPickersUtilsProvider>
    </Fragment>
  );
}

export default InlineDatePickerDemo;
